<template>
  <div class="ts-space-y-2">
		<div class="row">
			<div class="col-md-12">
				<label class="required ts-text-xs">{{ $t('tableProfile.tableNo') }}</label>
				<input
					v-model.trim="model.table_no" 
					type="text" 
					class="form-control"
				>
				<div class="validate" v-if="errors.has('table_no')">
					{{ errors.first('table_no') }}
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<label class="required ts-text-xs">{{ $t('tableProfile.type') }}</label>
				<select
					v-model="model.table_type"
					class="form-control">
					<option value="Standard">Standard</option>
					<option value="VIP">VIP</option>
				</select>
				<div class="validate" v-if="errors.has('table_type')">
					{{ errors.first('table_type') }}
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<label class="ts-text-xs">{{ $t('tableProfile.shape') }}</label>
				<input
					v-model="model.table_shape" 
					type="text" class="form-control">
				<div class="validate" v-if="errors.has('table_shape')">
					{{ errors.first('table_shape') }}
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<label class="required ts-text-xs">{{ $t('tableProfile.floor') }}</label>
				<input
					v-model="model.floors" 
					type="text" class="form-control">
				<div class="validate" v-if="errors.has('floors')">
					{{ errors.first('floors') }}
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<label class="required ts-text-xs">{{ $t('tableProfile.maxNumPerson') }}</label>
				<input
					v-model.number="model.max_num_person" 
					type="number" class="form-control">
				<div class="validate" v-if="errors.has('max_num_person')">
					{{ errors.first('max_num_person') }}
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<label class="required ts-text-xs">{{ $t('tableProfile.displayOrder') }}</label>
				<input
					v-model.number="model.display_order" 
					type="number" class="form-control">
				<div class="validate" v-if="errors.has('display_order')">
					{{ errors.first('display_order') }}
				</div>
			</div>
		</div>
		<div class="row">
      <div class="col-md-12 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
	</div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
	name: 'tableProfileForm',
	data(){
		return {
			errors: new Errors(),
      waiting: false,
      waiting_new: false,
			model: {
				table_no: null,
				table_shape: null,
				table_type: 'Standard',
				floors: '',
				max_num_person: null,
				display_order: 1
			}
		}
	},
	created() {
    this.setEditData()
  },
  computed: {
    ...mapState('booking/tableProfile', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
	},
	methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('booking/tableProfile/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('booking/tableProfile/update', {
          id: this.model.table_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
				this.model.table_id = this.edit_data.table_id
        this.model.table_no = this.edit_data.table_no
				this.model.table_shape = this.edit_data.table_shape
				this.model.table_type = this.edit_data.table_type
				this.model.floors = this.edit_data.floors
				this.model.max_num_person = this.edit_data.max_num_person
				this.model.display_order = this.edit_data.display_order
      }
    }
  }
}
</script>